// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";
// import { Toast } from 'vant'
// import 'vant/lib/index.css'
import Vant from 'vant';
import 'vant/lib/index.css'
// import '../src/assets/css/font.css';
Vue.use(Vant);
// axios.defaults.baseURL = 'url'

Vue.prototype.$http = axios

Vue.config.productionTip = false

// Vue.use(Toast)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js